import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentInfoLongText,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    labelEnabled: true,
    label: 'Input label',
    remaining: true,
    maximumCharacters: 500,
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
};
